import { render, staticRenderFns } from "./usergroups.vue?vue&type=template&id=0dc1f750&lang=pug"
import script from "./usergroups.vue?vue&type=script&lang=js"
export * from "./usergroups.vue?vue&type=script&lang=js"
import style0 from "./usergroups.vue?vue&type=style&index=0&id=0dc1f750&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports